import { put, takeEvery } from 'redux-saga/effects';
import { VIDEO_CONTENT_70 } from '../config';

import { GET_VIDEO_CONTENT, SET_VIDEO_CONTENT } from '../constants/card';

import { createAxios, logNative } from '../utils/utils';

/**
 *
 */
function* fetchVideoContent({ payload }) {
  try {
    yield put({
      type: SET_VIDEO_CONTENT,
      payload: {
        ...payload,
        loading: true,
      },
    });
    const axios = yield createAxios();
    const res = yield axios.get(VIDEO_CONTENT_70, { params: payload });
    if (res.data.status === 0) {
      yield put({
        type: SET_VIDEO_CONTENT,
        payload: { ...res.data.data, ...payload } || {},
      });
    } else {
      yield put({
        type: SET_VIDEO_CONTENT,
        payload: {
          videoUrl: null,
          duration: 0,
          ...payload,
        },
      });
    }
  } catch (error) {
    logNative(`获取视频内容出错${error}`);
    // throw error;
  }
  yield put({
    type: SET_VIDEO_CONTENT,
    payload: {
      ...payload,
      loading: false,
    },
  });
}

export function* watchFetchVideoContent() {
  yield takeEvery(GET_VIDEO_CONTENT, fetchVideoContent);
}
